import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "./App.css";
import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SolarSolutionsPage from "./pages/SolarSolutionsPage";
import ServicesPage from "./pages/ServicesPage";
import PartnerPage from "./pages/PartnerPage";
import InsightsFaqPage from "./pages/InsightsFaqPage";
import ArticlePage from "./pages/ArticlePage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import NotFoundPage from "./pages/NotFoundPage";

const lenisRef = { current: null };

const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  const raf = useRef(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    const loop = (t) => { lenis.raf(t); raf.current = requestAnimationFrame(loop); };
    raf.current = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf.current); lenis.destroy(); lenisRef.current = null; };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.getElementById(hash.slice(1)) : null;
      if (el) {
        if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -90 });
        else el.scrollIntoView();
      } else if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, hash ? 120 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};

const Layout = () => (
  <>
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded focus:bg-white focus:px-4 focus:py-2">Skip to content</a>
    <Navbar />
    <main id="main"><Outlet /></main>
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Toaster position="bottom-right" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/solutions" element={<SolarSolutionsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/insights" element={<InsightsFaqPage />} />
          <Route path="/insights/:slug" element={<ArticlePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
